import { observable, action } from "mobx";
import { post, get, put, deleted } from "../services/ajax.service";

class EntityStore {
  @observable programs = {
    precision_pgx: {
      name: "Precision Pgx",
      value: false
    },
    pcm_savings: {
      name: "Pcm Savings",
      value: false
    },
    rx_tourism: {
      name: "Rx Tourism",
      value: false
    },
    alternative_funding: {
      name: "Alternative Funding",
      value: false
    },
    international_rx: {
      name: "International Rx",
      value: false
    },
    specialty_carve_out: {
      name: "Specialty Review",
      value: false
    }
  }
  @observable step = 1;
  @observable entities = [];
  @observable broker_entities = []
  @observable limit = 10;
  @observable tiles = 0;
  @observable reportError = "";
  @observable entitiesselect = [];
  @observable action = false;
  @observable entity = {};
  @observable errors = {};
  @observable cust_groups = [];
  @observable precust_groups = [];
  @action setProgram = (name, value) => {

    this.programs[name].value = value
  }
  @action setStep = (step) => {
    this.step = step;
  }
  @action setErrors = () => {
    this.errors = {};
  };
  @action setAction = action => {
    this.action = action;
  };
  @action getBrokerEntities = async () => {
    try {

      let response = await get("/api/v1/entityactions/getBrokerEntities");
      this.broker_entities = response.data
    }
    catch (err) {
      console.log(err)
    }
  }
  @action setGroupApsName = (is_cust, id) => {
    let group_name = "";
    if (is_cust) {
      this.cust_groups.map(group => {
        if (group.id == id) {
          group_name = group.name;
        }
      })
    }
    else {
      this.precust_groups.map(group => {
        if (group.id == id) {
          group_name = group.name;
        }

      })
    }
    return group_name;
  }
  @action setGroupApsInstance = (is_cust, id) => {
    let group_instance = "";
    if (is_cust) {
      this.cust_groups.api_instance.map(group => {
        if (group.id == id) {
          group_instance = group.aps_instance;
        }
      })
    }
    else {
      this.precust_groups.api_instance.map(group => {
        if (group.id == id) {
          group_instance = group.aps_instance;
        }

      })
    }
    return group_instance;
  }

  @action getEntities = async data => {
    let entityData = [];
    if (data.type == "all") {
      entityData = await get(
        `/api/v1/entityactions/getall?limit=${this.limit}&&offset=${data.offset}&&search=${data.search}&&attr=${data.attr}`
      );
    }
    else {
      entityData = await get(
        `/api/v1/entityactions/getall/${data.type}?limit=${this.limit}&&offset=${data.offset}&&search=${data.search}&&attr=${data.attr}`
      );
    }
    this.entities = entityData.data.rows;
    let count = parseInt(entityData.data.count);
    this.tiles =
      count % this.limit == 0
        ? parseInt(count / this.limit)
        : parseInt(count / this.limit) + 1;
  };

  @action getEntity = async id => {
    const entityData = await get(`/api/v1/entityactions/get/${id}`);

    return entityData.data;
  };

  @action selectEntities = async (type, id = 0) => {
    const entities = await get(
      `/api/v1/entityactions/listentity/${type}?id=${id}`
    );
    this.entitiesselect = entities.data;
  };

  @action addEntity = async (data, history) => {
    try {
      await post(`/api/v1/entityactions/create`, data);
      this.action = true;
      this.setStep(1)
      history.push("/portalmanagement/entities");
    } catch (e) {
      this.errors = e.response.data;
      this.setStep(1)
    }
  };

  @action deleteEntity = async (id, history) => {
    try {
      await deleted(`/api/v1/entityactions/delete/${id}`);
      var filtered = this.entities.filter(entity => entity.id !== id);
      this.entities = filtered;
    } catch (e) {
      console.log(e);
    }
  };

  @action editEntity = async (data, id, history) => {
    try {
      await put(`/api/v1/entityactions/update/${id}`, data);
      this.action = true;
      history.push("/portalmanagement/entities");
    } catch (e) {
      this.errors = e.response.data;
    }
  };

  @action getPreCustGroups = async () => {
    try {
      let groups = await get("/api/v1/entityactions/listgroups/precust");
      this.cust_groups = groups.data;
    } catch (e) {
      console.log(e);
    }
  };
  @action getCustGroups = async () => {
    try {
      let groups = await get("/api/v1/entityactions/listgroups/cust");
      this.precust_groups = groups.data;
    } catch (e) {
      console.log(e);
    }
  };

  @action getEntityReport = async (data) => {
    try {
      this.reportError = "";
      let result = await post(`/api/v1/entityactions/getEntityReport`, data);
      return true
    } catch (e) {
      this.reportError = e.response.data
      console.log(e);
    }
  }

}

export default EntityStore;
